import script from "./PageLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageLoading.vue?vue&type=script&lang=ts&setup=true"

import "./PageLoading.vue?vue&type=style&index=0&id=2c91db51&lang=css"

const __exports__ = script;

export default __exports__